import {AfriexCountryCode, AfriexCurrencyCode} from '@/types';

export const countryCodeToCurrencyCodeMap: Partial<
  Record<AfriexCountryCode, AfriexCurrencyCode>
> = {
  [AfriexCountryCode.NG]: AfriexCurrencyCode.NGN,
  [AfriexCountryCode.GB]: AfriexCurrencyCode.GBP,
  [AfriexCountryCode.US]: AfriexCurrencyCode.USD,
  [AfriexCountryCode.CA]: AfriexCurrencyCode.CAD,
  [AfriexCountryCode.KE]: AfriexCurrencyCode.KES,
  [AfriexCountryCode.GH]: AfriexCurrencyCode.GHS,
  [AfriexCountryCode.UG]: AfriexCurrencyCode.UGX,
  [AfriexCountryCode.CM]: AfriexCurrencyCode.XAF,
  [AfriexCountryCode.CG]: AfriexCurrencyCode.XAF,
  [AfriexCountryCode.GA]: AfriexCurrencyCode.XAF,
  [AfriexCountryCode.CF]: AfriexCurrencyCode.XAF,
  [AfriexCountryCode.ET]: AfriexCurrencyCode.ETB,
  [AfriexCountryCode.HT]: AfriexCurrencyCode.HTG,
  [AfriexCountryCode.AT]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.BE]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.HR]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.CY]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.EE]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.FI]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.FR]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.DE]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.GR]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.IE]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.IT]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.LV]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.LT]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.LU]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.MT]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.NL]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.PT]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.SK]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.SI]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.ES]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.RO]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.BG]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.CZ]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.DK]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.HU]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.PL]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.SE]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.NO]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.UA]: AfriexCurrencyCode.EUR,
  [AfriexCountryCode.AU]: AfriexCurrencyCode.AUD,
  [AfriexCountryCode.RU]: AfriexCurrencyCode.RUB,
  [AfriexCountryCode.BF]: AfriexCurrencyCode.XOF,
  [AfriexCountryCode.ML]: AfriexCurrencyCode.XOF,
  [AfriexCountryCode.SN]: AfriexCurrencyCode.XOF,
  [AfriexCountryCode.TG]: AfriexCurrencyCode.XOF,
  [AfriexCountryCode.GN]: AfriexCurrencyCode.GNF,
  [AfriexCountryCode.BJ]: AfriexCurrencyCode.XOF,
  [AfriexCountryCode.CI]: AfriexCurrencyCode.XOF,
  [AfriexCountryCode.NE]: AfriexCurrencyCode.XOF,
  [AfriexCountryCode.GW]: AfriexCurrencyCode.XOF,
  [AfriexCountryCode.EG]: AfriexCurrencyCode.EGP,
  [AfriexCountryCode.MX]: AfriexCurrencyCode.MXN,
  [AfriexCountryCode.CN]: AfriexCurrencyCode.CNY,
  [AfriexCountryCode.IN]: AfriexCurrencyCode.INR,
  [AfriexCountryCode.PH]: AfriexCurrencyCode.PHP,
  [AfriexCountryCode.BR]: AfriexCurrencyCode.BRL,
  [AfriexCountryCode.UY]: AfriexCurrencyCode.UYU,
  [AfriexCountryCode.PK]: AfriexCurrencyCode.PKR,
  [AfriexCountryCode.RW]: AfriexCurrencyCode.RWF,
  [AfriexCountryCode.ZA]: AfriexCurrencyCode.ZAR,
  [AfriexCountryCode.TZ]: AfriexCurrencyCode.TZS,
  [AfriexCountryCode.ZM]: AfriexCurrencyCode.ZMW,
  [AfriexCountryCode.MZ]: AfriexCurrencyCode.MZN,
  // Each of these is a real mobile-money corridor on the server side but was
  // missing here, which silently broke currency resolution for these
  // countries in pool-account/pool-transaction forms.
  [AfriexCountryCode.MW]: AfriexCurrencyCode.MWK,
  [AfriexCountryCode.SL]: AfriexCurrencyCode.SLE,
  [AfriexCountryCode.CD]: AfriexCurrencyCode.CDF,
  [AfriexCountryCode.DJ]: AfriexCurrencyCode.DJF,
  [AfriexCountryCode.GM]: AfriexCurrencyCode.GMD,
  [AfriexCountryCode.LR]: AfriexCurrencyCode.LRD,
  [AfriexCountryCode.MA]: AfriexCurrencyCode.MAD,
  [AfriexCountryCode.MG]: AfriexCurrencyCode.MGA,
  [AfriexCountryCode.SS]: AfriexCurrencyCode.SSP,
  [AfriexCountryCode.BW]: AfriexCurrencyCode.BWP,
  [AfriexCountryCode.ZW]: AfriexCurrencyCode.ZWL,
};
